import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";

const emptyForm = {
  code: "",
  name: "",
  sortOrder: 0,
  isActive: true,
};

export default function SizeGroupModal({
  open,
  onClose,
  onSave,
  initialData = null,
}) {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (open) {
      setForm(
        initialData
          ? {
              code: initialData.code || "",
              name: initialData.name || "",
              sortOrder: initialData.sortOrder ?? 0,
              isActive: initialData.isActive ?? true,
            }
          : emptyForm,
      );
    }
  }, [open, initialData]);

  if (!open) return null;

  const handleSubmit = (event) => {
    event.preventDefault();

    onSave({
      code: form.code.trim().toUpperCase(),
      name: form.name.trim(),
      sortOrder: Number(form.sortOrder) || 0,
      isActive: form.isActive,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm">
      <div className="w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-8 py-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {initialData ? "Edit Size Group" : "Add Size Group"}
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Group compatible sizes for one or more subcategories.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-100 text-gray-600 hover:bg-gray-200"
          >
            <FiX size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-6 p-8">
            <div>
              <label className="mb-2 block text-sm font-medium text-gray-700">
                Group Name *
              </label>
              <input
                type="text"
                value={form.name}
                placeholder="Jeans Sizes"
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    name: event.target.value,
                  }))
                }
                className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-medium text-gray-700">
                Group Code *
              </label>
              <input
                type="text"
                value={form.code}
                placeholder="JEANS"
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    code: event.target.value.toUpperCase(),
                  }))
                }
                className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-medium text-gray-700">
                Display Order
              </label>
              <input
                type="number"
                min="0"
                value={form.sortOrder}
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    sortOrder: event.target.value,
                  }))
                }
                className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-medium text-gray-700">
                Status
              </label>
              <select
                value={form.isActive ? "active" : "inactive"}
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    isActive: event.target.value === "active",
                  }))
                }
                className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div className="flex justify-end gap-3 border-t border-gray-100 px-8 py-5">
            <button
              type="button"
              onClick={onClose}
              className="h-11 rounded-xl border border-gray-200 px-6 text-sm font-medium hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="h-11 rounded-xl bg-primary-800 px-6 text-sm font-medium text-white hover:bg-primary-900"
            >
              {initialData ? "Save Changes" : "Create Size Group"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}